import { render, staticRenderFns } from "./SysNotice.vue?vue&type=template&id=78fcea39&scoped=true&"
import script from "./SysNotice.vue?vue&type=script&lang=js&"
export * from "./SysNotice.vue?vue&type=script&lang=js&"
import style0 from "./SysNotice.vue?vue&type=style&index=0&id=78fcea39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fcea39",
  null
  
)

export default component.exports